import React, { useCallback, useMemo } from 'react'
import { generatePath, useParams } from 'react-router-dom'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { useApiQuery } from 'admin/lib/Api'
import { EditSmartWaste } from './EditSmartWaste'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import * as ROUTES from 'admin/routes'
import styled from 'styled-components'

export function SmartWaste() {
  const { accountId, projectId } = useParams()

  const account = useApiQuery(
    useCallback(api => api.getAccount(accountId), [accountId])
  )
  const project = useApiQuery(
    useCallback(
      api => api.getProject(accountId, projectId),
      [accountId, projectId]
    )
  )

  const context = useMemo(() => {
    return {
      loaded: account.loaded && project.loaded,
      account: account.data,
      project: project.data
    }
  }, [account.data, account.loaded, project.data, project.loaded])

  const swconfig = useApiQuery(
    useCallback(
      api => api.getSmartWasteConfig(accountId, projectId),
      [accountId, projectId]
    )
  )

  // defaultSWProjectId current is returned as a number (all other values are strings)
  // To get the form validation rules to work correctly we will convert this to a string
  if (
    swconfig.data &&
    swconfig.data.defaultSWProjectId &&
    typeof swconfig.data.defaultSWProjectId === 'number'
  ) {
    swconfig.data.defaultSWProjectId =
      swconfig.data.defaultSWProjectId.toString()
  }

  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: (
                <BreadcrumbArrayItem href={generatePath(ROUTES.ACCOUNTS.LIST)}>
                  Accounts
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem
                  loading={!context.loaded}
                  href={generatePath(ROUTES.PROJECTS.LIST, {
                    accountId: accountId
                  })}
                >
                  {context.account?.name}
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem
                  loading={!context.loaded}
                  href={generatePath(ROUTES.PROJECTS.LIST, {
                    accountId: accountId
                  })}
                >
                  Projects
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem loading={!context.loaded}>
                  {context.project?.name}
                </BreadcrumbArrayItem>
              )
            },
            {
              title: 'SmartWaste Integration'
            }
          ]}
        />
      }
    >
      {!swconfig.loaded && <ScreenSpin />}

      {swconfig.loaded && (
        <EditSection>
          <EditSmartWaste
            configData={swconfig.data}
            isNew={swconfig.status === 404}
          />
        </EditSection>
      )}
    </Layout>
  )
}

const EditSection = styled.div`
  margin: auto;
  width: 30rem;
`
